import React from "react"
import { Link } from "gatsby"
import logo from "../images/logo.png"
import Layout from "../components/layout"
import ipad from "../images/iPad.png"
import SEO from "../components/seo"
import Card from "../components/Card"
import Section from "../components/Section"
import Wave from "../components/Wave"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" keywords={[`gatsby`, `application`, `react`]} />
    <div className="Hero">
      <div className="HeroGroup">
        <img src={logo} style={{ width: "175px", height: "175px" }} />
        <h1>The Views News</h1>
        <h2>Your News. Your Voice. Your Views.</h2>
        <p>
          Welcome to a new take on your news. Skim the headlines, view people's
          opinions, and let your voice be heard!
        </p>
        <div className="Logos">
          <a href="https://geo.itunes.apple.com/us/app/the-views-news/id1322754821?mt=8">
            <img
              src={require("../images/appstore.png")}
              style={{ width: "55px", height: "55px" }}
            />
          </a>
          <a href="https://www.amazon.com/dp/B07Q341CCK/">
            <img
              src={require("../images/alexa.png")}
              style={{ width: "50px", height: "50px" }}
            />
          </a>
          <a href="https://assistant.google.com/services/a/uid/000000dba78598c4">
            <img
              src={require("../images/assistant.png")}
              style={{ width: "50px", height: "50px" }}
            />
          </a>
          <a href="https://www.producthunt.com/posts/the-views-news">
            <img
              src={require("../images/product-hunt-icon.png")}
              style={{ width: "50px", height: "50px" }}
            />
          </a>
          <a href="https://medium.com/views-weekly">
            <img
              src={require("../images/Medium.png")}
              style={{ width: "50px", height: "50px" }}
            />
          </a>
        </div>
      </div>
      <svg
        width="100%"
        height="172"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="rgba(255,255,255,0.5)">
          <animate
            repeatCount="indefinite"
            fill="freeze"
            attributeName="d"
            dur="6s"
            values="M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z;
                M0 53.6584C158 11.0001 213 0 363 0C513 0 855.555 115.001 1154 115.001C1440 115.001 1626 -38.0004 2560 53.6585V199.66L0 199.66V53.6584Z;
                M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z"
          />
        </path>
      </svg>
      <svg
        width="100%"
        height="150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="rgba(255,255,255,1.0)">
          <animate
            repeatCount="indefinite"
            fill="freeze"
            attributeName="d"
            dur="10s"
            values="M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z;
                  M0 53.6584C158 11.0001 213 0 363 0C513 0 855.555 115.001 1154 115.001C1440 115.001 1626 -38.0004 2560 53.6585V199.66L0 199.66V53.6584Z;
                  M0 25.9086C277 84.5821 433 65.736 720 25.9086C934.818 -3.9019 1214.06 -5.23669 1442 8.06597C2079 45.2421 2208 63.5007 2560 25.9088V171.91L0 171.91V25.9086Z"
          />
        </path>
      </svg>
    </div>
    <div className="Cards">
      <a id="Features" />
      <h2>Features</h2>
      <div className="CardGroup">
        <a href="/whats-new">
          <Card
            title="Current"
            subtitle="The headlines are always up to date"
            image="https://s22.postimg.cc/l8fzdylw1/Viewpoints.png"
          />
        </a>
        <a href="/whats-new">
          <Card
            title="Felicity"
            subtitle="A.I. News Searching"
            image="https://s22.postimg.cc/cq6j9musx/Felicity.png"
          />
        </a>
        <Card
          title="Community"
          subtitle="Share your thoughts on trending stories"
          image="https://s22.postimg.cc/puc3marzl/Polls.png"
        />
        <a href="/whats-new">
          <Card
            title="Authenticity"
            subtitle="Share your views with real people worldwide"
            image="https://s22.postimg.cc/mnhk2of9d/Profiles.png"
          />
        </a>
        <a href="/whats-new">
          <Card
            title="Notifications"
            subtitle="Stay on top of the news with timed notifications"
            image="https://s22.postimg.cc/4kohbgyu9/Views_Weekly.png"
          />
        </a>
        <a href="/whats-new">
          <Card
            title="Universal"
            subtitle="Available on all Apple devices"
            image="https://s22.postimg.cc/fk9on1ue9/Universal.png"
          />
        </a>
      </div>
    </div>
    <Section
      image="https://s22.postimg.cc/fsq7magoh/Night.png"
      logo={require("../images/checkmark.png")}
      title="Community Fact Check"
      text="There's a lot of noise in today's social medias and it can be hard to determine what's true and what's fake. We decided we had enough of the shouting matches online so we decided to build a place for people to have smart discussions on the latest news. Contribute to the Community, let your voice be heard, and share your collective knowledge for everylone to learn from."
    />
    <div className="Cards">
      <div className="AppSection">
        <img src={ipad} width="100%" />
        <a href="https://geo.itunes.apple.com/us/app/the-views-news/id1322754821?mt=8">
          <img
            src="https://i.postimg.cc/MpSJ8dVB/button-appstore-en.png"
            width="241px"
          />
        </a>
      </div>
    </div>
  </Layout>
)

export default IndexPage
